import React from "react"
import ReactDOM from "react-dom"
import EditProfileComponent from "./edit-profile-component"

const EditProfileModule = (elem) => {
  const modelJson = elem.dataset.modelJson && JSON.parse(elem.dataset.modelJson)
  const profileJson = elem.dataset.modelProfile && JSON.parse(elem.dataset.modelProfile)
  const countriesJson = elem.dataset.modelCountries && JSON.parse(elem.dataset.modelCountries)
  const isGoogleLinked = elem.dataset.modelGoogleLinked && JSON.parse(elem.dataset.modelGoogleLinked)
  const isFacebookLinked = elem.dataset.modelFacebookLinked && JSON.parse(elem.dataset.modelFacebookLinked)
  const hosts = elem.dataset.modelHosts && JSON.parse(elem.dataset.modelHosts)
  const contentLink = elem.dataset.modelContentLink && JSON.parse(elem.dataset.modelContentLink)
  const marketingConsentCurrent = elem.dataset.modelMarketingConsentCurrent && JSON.parse(elem.dataset.modelMarketingConsentCurrent)
  const marketingConsentLatest = elem.dataset.modelMarketingConsentLatest && JSON.parse(elem.dataset.modelMarketingConsentLatest)
  const parkingConsentCurrent = elem.dataset.modelParkingConsentCurrent && JSON.parse(elem.dataset.modelParkingConsentCurrent)
  const parkingConsentLatest = elem.dataset.modelParkingConsentLatest && JSON.parse(elem.dataset.modelParkingConsentLatest)

  ReactDOM.unmountComponentAtNode(elem)
  ReactDOM.render(
    <EditProfileComponent
      lang={document?.body?.dataset?.language}
      hosts={hosts}
      profile={profileJson}
      countries={countriesJson}
      isGoogleLinked={isGoogleLinked}
      isFacebookLinked={isFacebookLinked}
      contentLink={contentLink?.ID || 0}
      marketingConsentCurrent={marketingConsentCurrent}
      marketingConsentLatest={marketingConsentLatest}
      parkingConsentCurrent={parkingConsentCurrent}
      parkingConsentLatest={parkingConsentLatest}
      labels={modelJson}
    />,
    elem,
  )
}

export default EditProfileModule
